<template>
  <div class="pd20x flex1">
    <SendGoods :visible="openClasses" @close="openClasses = false" detail_type="1" :options="options" :data="currentItem" :edit="editClass" @update="getData"></SendGoods>
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px">
        <div>订单数量（{{ pagination.total }}个） </div>
        <div>
          <label>搜索：</label>
          <a-input-search v-model="filter.keywords" placeholder="搜索订单商品标题" style="width: 200px" @search="()=>{pagination.page = 1;getData()}" class="mr10px"/>
          <a-button type="primary" @click="openClasses = true; currentItem = null; editClass = false">赠送商品</a-button>
        </div>
      </div>
      <a-table
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          :rowKey="'id'"
          @change="changePage"
      >
        <template slot="index" slot-scope="text, record">
          {{record.order_no}}
        </template>
        <template slot="status" slot-scope="text">
          {{ text | statusFilter }}
        </template>
        <template slot="create_time" slot-scope="text">
          {{formatDate(text*1000)}}
        </template>
        <template slot="type" slot-scope="text, record">
          <span v-if="record.type == 1">虚拟产品</span>
          <span v-if="record.type == 2">实物产品</span>
        </template>
        <template slot="shipping" slot-scope="text, record">
          <div v-if="record.type == 2">
            <div v-if="record.shipping_type == 2">
              <a-tag color="blue">邮寄</a-tag>
              <div style="font-size: 12px; margin-top: 4px;">
                <strong>收货人:</strong> {{ record.consignee }} ({{ record.phone }})
              </div>
              <div style="font-size: 12px;">
                <strong>地址:</strong> {{ record.address }}
              </div>
              <div v-if="record.express_no" style="margin-top: 4px; font-size: 12px; color: #e96d29;">
                <a-icon type="car" /> {{ record.express_company || '快递' }}: {{ record.express_no }}
              </div>
            </div>
            <div v-else-if="record.shipping_type == 1">
              <a-tag color="orange">自提</a-tag>
              <div style="font-size: 12px; margin-top: 4px;">
                <strong>提货人:</strong> {{ record.consignee }} ({{ record.phone }})
              </div>
            </div>
            <div v-else>
              <a-tag color="orange">自提</a-tag>
              <div style="font-size: 12px; margin-top: 4px; color: #999;">无配送信息</div>
            </div>
          </div>
          <div v-else>
            <a-tag color="green">虚拟产品</a-tag>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-tooltip title="详情"><i class="z-icon editB mr10px" @click="routerChange('详情', '/exam/theoryDetail', {id:record.id})"></i></a-tooltip>
          <a-tooltip title="删除"><i class="z-icon delete mr10px" @click="deleteItem(record.id)"></i></a-tooltip>
          
          <a-button 
            v-if="record.status == 1 && record.type == 2 && record.shipping_type == 2" 
            type="primary" 
            size="small" 
            @click="handleSend(record)"
            class="mr10px"
          >
            发货
          </a-button>
          
          <a-button 
            v-if="record.status == 1 && record.type == 2 && record.shipping_type == 1" 
            type="success" 
            size="small" 
            style="background-color: #52c41a; border-color: #52c41a; color: #fff;"
            @click="handleConfirm(record)"
            class="mr10px"
          >
            核销
          </a-button>

          <a-button 
            v-if="record.status == 1 && record.type == 1" 
            type="success" 
            size="small" 
            style="background-color: #52c41a; border-color: #52c41a; color: #fff;"
            @click="handleConfirm(record)"
            class="mr10px"
          >
            完成
          </a-button>

          <a-button 
            v-if="record.status == 2" 
            type="dashed" 
            size="small" 
            @click="handleConfirm(record)"
          >
            确认收货
          </a-button>
        </template>
      </a-table>

      <!-- 发货弹窗 -->
      <a-modal
        title="商品订单发货"
        :visible="sendModalVisible"
        :confirm-loading="sendLoading"
        @ok="submitSend"
        @cancel="sendModalVisible = false"
      >
        <div v-if="currentRecord" style="padding: 10px 0;">
          <p><strong>订单号:</strong> {{ currentRecord.order_no }}</p>
          <p><strong>收货人:</strong> {{ currentRecord.consignee }} ({{ currentRecord.phone }})</p>
          <p><strong>收货地址:</strong> {{ currentRecord.address }}</p>
          <div style="margin-top: 15px;">
            <div style="margin-bottom: 8px;"><strong>快递公司:</strong></div>
            <a-select 
              v-model="sendData.express_company" 
              placeholder="请选择或输入快递公司" 
              show-search
              style="width: 100%; margin-bottom: 15px;"
            >
              <a-select-option value="顺丰速运">顺丰速运</a-select-option>
              <a-select-option value="邮政快递包裹">邮政快递包裹</a-select-option>
              <a-select-option value="中通快递">中通快递</a-select-option>
              <a-select-option value="圆通速递">圆通速递</a-select-option>
              <a-select-option value="申通快递">申通快递</a-select-option>
              <a-select-option value="韵达快递">韵达快递</a-select-option>
              <a-select-option value="极兔速递">极兔速递</a-select-option>
              <a-select-option value="京东快递">京东快递</a-select-option>
            </a-select>
            <div style="margin-bottom: 8px;"><strong>快递单号:</strong></div>
            <a-input 
              v-model="sendData.express_no" 
              placeholder="请输入快递单号" 
            />
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
const columns = [{
  title: '订单号',
  scopedSlots: { customRender: 'index' },
  align:'center'
},
  {
    title: '商品标题',
    dataIndex: 'title',
    align:'center'
  }, {
    title: '商品类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
    align:'center'
  }, {
    title: '实际支付',
    dataIndex: 'price',
    align:'center',
  }, {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align:'center'
  }, {
    title: '配送信息',
    key: 'shipping',
    scopedSlots: { customRender: 'shipping' },
    align: 'left',
    width: 250
  }, {
    title: '创建时间',
    dataIndex: 'create_time',
    scopedSlots: { customRender: 'create_time' }
  }, {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];
const statusList = {
  0 : '代付款',
  1 : '待发货',
  2 : '待收货',
  3 : '已完成',
  5 : '已取消'
};


import SendGoods from '@/components/exam/sendGoods'
import * as http from '@/libs/examapi'
import { routerlink } from '@/mixins/routerlink'
import {formatDate} from '@/libs/moment'
export default {
  name: 'ordersList',
  components: { SendGoods },
  mixins: [routerlink],
  data(){
    return{
      options: [],
      columns,
      filter:{
        cate_id: 0,
        keywords:''
      },
      pagination:{
        page: 1,
        size: '15',
        pageSize: 15
      },
      data: [],
      areaval: '',
      openClasses: false,
      currentItem:'',
      editClass:false,
      sendModalVisible: false,
      sendLoading: false,
      currentRecord: null,
      sendData: {
        express_company: '',
        express_no: ''
      }
    }
  },
  filters: {
    statusFilter (status) {
      return statusList[status]
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.getData()
    })
  },
  methods:{
    formatDate,
    getData(){
      let request = {...this.filter,...this.pagination,detail_type:1}
      if(this.filter.cate_id == 0){
        request.cate_id = null
      }
      http.get_orders_list(request).then(res=>{
        const pagination = { ...this.pagination }
        pagination.total = res.total;
        this.data = res.data
        this.pagination = pagination;

      }).catch(error=>{
        console.log(error)
      })
    },
    deleteItem(id){
      let _this = this
      this.$confirm({
        title: '是否确定删除该套卷信息?',
        centered: true,
        onOk() {
          http.del_crouse_bag({id}).then(res=>{
            let {page, pagesize, total} = _this.pagination
            if(page>1 && Number(page-1)* 15 == total - 1){
              _this.pagination.page = Number(page-1)
            }
            _this.getData()
          }).catch(error=>{
            console.log(error)
          })
        },
      });
    },
    changePage({current}){
      this.pagination.page = current
      this.getData()
    },
    handleSend(record) {
      this.currentRecord = record
      this.sendData.express_company = ''
      this.sendData.express_no = ''
      this.sendModalVisible = true
    },
    submitSend() {
      if (!this.sendData.express_company) {
        this.$message.warning('请选择或输入快递公司')
        return
      }
      if (!this.sendData.express_no) {
        this.$message.warning('请输入快递单号')
        return
      }
      this.sendLoading = true
      http.sendOrder({
        order_id: this.currentRecord.id,
        express_company: this.sendData.express_company,
        express_no: this.sendData.express_no,
        is_send_sms: 0
      }).then(res => {
        this.$message.success('发货成功')
        this.sendModalVisible = false
        this.getData()
      }).catch(err => {
        console.error(err)
        this.$message.error('发货失败')
      }).finally(() => {
        this.sendLoading = false
      })
    },
    handleConfirm(record) {
      const _this = this
      let tipMsg = '是否确认收货？'
      if (record.shipping_type == 1) {
        tipMsg = '是否确认提货核销该订单？'
      } else if (record.type == 1) {
        tipMsg = '是否确认完成该虚拟商品订单？'
      }
      
      this.$confirm({
        title: tipMsg,
        centered: true,
        onOk() {
          return http.confirmOrder({
            order_id: record.id
          }).then(res => {
            _this.$message.success('操作成功')
            _this.getData()
          }).catch(err => {
            console.error(err)
            _this.$message.error('操作失败')
          })
        }
      })
    },
    hideModal(){

    },
    onChange(){

    }
  }
}
</script>
<style lang="less" scoped>
.imgWrap{
  width: 120px;
  height: 70px;
  overflow: hidden;
  border-radius: 4px;
  img{
    width: 100%;
  }
}
</style>